import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-people-nophotos',
  templateUrl: './people-nophotos.component.html',
  styles: [
  ]
})
export class PeopleNophotosComponent implements OnInit {

  @Input() dataPeople;
  
  constructor() { }

  ngOnInit(): void {
  }

}
